import React from 'react';
import { ListItem } from 'material-ui/List';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import colors from '../../themes/colors';

const SignupListItem = ({ icon, text }) => (
  <ListItem
    disabled
    leftIcon={!icon ? <CheckCircle color={colors.blue} /> : icon}
    primaryText={text}
  />
);

export default SignupListItem;



// WEBPACK FOOTER //
// ./src/components/SignupListItem/index.jsx